
const findVariantWithColorUtil = (variantRedux, selectedColorOption) => {
  return variantRedux?.find(
    variant =>
      variant.color_option === selectedColorOption ||
        variant.option_value === selectedColorOption
  )
}

export default findVariantWithColorUtil
